import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "../auth/authSlice";
import {
  getFavorites,
  addFavorite,
  removeFavorite,
} from "./favoritesActions";

const initialState = {
  loading: false,
  error: null,
  items: [], // current page of the favorites list (results)
  meta: null, // pagination meta from the server
  overrides: {}, // { [menuItemId]: bool } — local heart state after toggles
};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    resetFavoritesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    const applyPending = (state) => {
      state.loading = true;
    };
    const applyRejected = (state, action) => {
      state.loading = false;
      state.error = action.payload;
    };
    builder
      .addCase(getFavorites.pending, applyPending)
      .addCase(getFavorites.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.items = action.payload?.results || [];
        state.meta = action.payload?.meta || null;
      })
      .addCase(getFavorites.rejected, applyRejected)
      .addCase(addFavorite.pending, applyPending)
      // add/remove no longer return the list — they answer with the
      // server-confirmed flag: { menu_item_id, is_favorite }.
      .addCase(addFavorite.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.overrides[action.payload?.menu_item_id] = true;
      })
      .addCase(addFavorite.rejected, applyRejected)
      .addCase(removeFavorite.pending, applyPending)
      .addCase(removeFavorite.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.overrides[action.payload?.menu_item_id] = false;
      })
      .addCase(removeFavorite.rejected, applyRejected)
      // Logout: favorites stay saved on the server for next login; the local
      // copy is cleared so nothing leaks to the next guest on this browser.
      .addCase(logOut, (state) => {
        state.items = [];
        state.meta = null;
        state.overrides = {};
      });
  },
});

export const { resetFavoritesError } = favoritesSlice.actions;
export default favoritesSlice.reducer;
